import { useContext } from 'react';

import { LanguageContext } from 'src/contexts';
//123321
export const useTranslation = () => useContext(LanguageContext);
